import React from "react";
import { registerPassages } from "../../Utils";
import variables from "../variables";
import Passage from "../../features/Passage";
import Link from "../../features/Link";
import Image from "../../features/Image";
import Say from "../../features/Say";
import images from "../images";
import {addTimePart, changeTimeTo} from "../features/functions";
import people from "../people/people";
import Name from "../../features/Name";
import {Trans} from "react-i18next";

const wakeup = <Passage>
    <Trans i18nKey="day01.wakeup">
        1<h1/><Name who={people.wife}/><Image src={images.wife.occupations.sleep["01"]} /><br/>
        <Link to="day01.kissWife"/><Link to="day01.underCoves"/><Link to="day01.shower"/>
    </Trans>
</Passage>

const kissWife = <Passage>
    <Trans i18nKey="day01.kissWife">
        1<h1/><Image src={images.actions.morningKiss}/><Name who={people.wife}/><Link to="day01.shower"/>
    </Trans>
</Passage>

const underCoves = <Passage>
    <Trans i18nKey="day01.underCoves">
        1<h1/><Name who={people.wife}/><Name who={people.wife} nickname/><Image src={images.wife.actions.undercoves.u01}/>
        <Link to="day01.shower"/>
    </Trans>
</Passage>

const shower = <Passage>
    <Trans i18nKey="day01.shower">
        1<h1/><Image src={images.player.shower.shower01}/>
        <Link to="day01.afterShower" callback={() => {people.wife.occupations.set("wakeup", "dress")}}/>
    </Trans>
</Passage>

const afterShower = <Passage>
    <Trans i18nKey="day01.afterShower">
        1<h1/><Name who={people.wife}/><Say who={people.wife}/><Image src={images.wife.occupations.wakeup.dress}/>
        <Say who={people.player}/><br/>
        <Link to="day01.drinkCoffeeAlone" callback={() => {people.wife.occupations.set("shower")}}/>
    </Trans>
</Passage>

const drinkCoffeeAlone = <Passage>
    <Trans i18nKey="day01.drinkCoffeeAlone">
        1<h1/><Image src={images.player.coffee}/><Name who={people.wife}/><Image src={images.day01.instagram.kitty}/>
        <Image src={images.day01.instagram.car}/><Image src={images.day01.instagram.carWoman}/>
        <Image src={images.day01.instagram.carWoman2}/><Image src={images.day01.instagram.carWoman3}/>
        <Say who={people.wife}/><br/>
        <Link
            to="day01.drinkCoffeeWithWife"
            callback={() => {people.wife.occupations.set(people.wife.occupations.appearance.id)}}/>
    </Trans>
</Passage>

const drinkCoffeeWithWife = <Passage>
    <Trans i18nKey="day01.drinkCoffeeWithWife">
        1<Say who={people.player}/>
        <Say who={people.wife}/>
        <Name who={people.wife}/>
        <Image src={images.day01.drinkCoffeeWithWife}/>
        <Link to="day01.goToWork" callback={() => {people.wife.occupations.set("breakfast")}}/><h1/>
        {{wife: people.wife.name}}
    </Trans>
</Passage>

const goToWork = <Passage>
    <Trans i18nKey="day01.goToWork">
        1<h1/><Image src={images.player.drive.oldBMW}/><Image src={images.day01.traffic}/><strong/>
        <Link to="day01.officeArrival" callback={() => {
            people.wife.occupations.set("reading");
            addTimePart();}}/>
    </Trans>
</Passage>

const officeArrival = <Passage>
    <Trans i18nKey="day01.officeArrival">
        1<h1/><Image src={images.day01.fatherOffice}/><h3 style={{paddingTop: "1em"}}/>
        <Image src={images.people.father}/><h3 style={{paddingTop: "1em"}}/>
        <Image src={images.people.sister}/><Say who={people.father}/><Say who={people.player}/>
        <Say who={people.sister}/><Name who={people.sister}/><Link to="day01.fatherAssignment"/><br/>
        {{sister: people.sister.name, player: people.player.name, city: variables.city.name}}
    </Trans>
</Passage>

const fatherAssignment = <Passage>
    <Trans i18nKey="day01.fatherAssignment">
        1<h1/><Image src={images.day01.fatherOffice}/><Say who={people.father}/><Say who={people.sister}/>
        <Name who={people.sister}/><Say who={people.player}/><Link to="day01.fatherOneToOne"/>
        {{pillsMan: people.pillsManufacturer.name, city: variables.city.name, player: people.player.name, sister: people.sister.name}}
    </Trans>
</Passage>

const fatherOneToOne = <Passage>
    <Trans i18nKey="day01.fatherOneToOne">
        1<h1/><Image src={images.day01.fatherOffice}/><Image src={images.people.father}/><Name who={people.sister}/>
        <Say who={people.father}/><Say who={people.player}/>
        <Link to="day01.atThreePM" callback={() => {
            people.wife.occupations.set("lessons");
            people.player.sendNewMessage("mes02");
            changeTimeTo(1, 1, 0);}}/>
        {{player: people.player.name, pillsMan: people.pillsManufacturer.name, wife: people.wife.name}}
    </Trans>
</Passage>

const atThreePM = <Passage>
    <Trans i18nKey="day01.atThreePM">
        1<h1/><Name who={people.pillsManufacturer}/><Image src={images.people.pillsManufacturer}/>
        <Say who={people.player}/><Say who={people.pillsManufacturer}/><Image src={images.other.pillsPack}/>
        <Link to="day01.goBackToOffice"/>
        {{pillsMan: people.pillsManufacturer.name, playerSurname: people.player.surname}}
    </Trans>
</Passage>

const goBackToOffice = <Passage>
    <Trans i18nKey="day01.goBackToOffice">
        1<h1/><Image src={images.day01.downtown}/><strong/><Say who={people.father}/><Say who=""/><Say who={people.player}/>
        <Link to="day01.taxi" callback={()=>{people.player.sendNewMessage("mes03")}}/>
        {{player: people.player.name}}
    </Trans>
</Passage>

const taxi = <Passage>
    <Trans i18nKey="day01.taxi">
        1<h1/><Image src={images.day01.taxi}/><Say who={people.sister}/><Name who={people.sister}/><Say who=""/><Say who={people.player}/>
        <Link to="day02.oldLifeEnd" callback={() => {
            people.wife.occupations.set("appearance", "appearance01");
            variables.game.wasStarted = false;}}/><br/>
        {{player: people.player.name}}
    </Trans>
</Passage>

registerPassages({
    wakeup,
    kissWife,
    underCoves,
    shower,
    afterShower,
    drinkCoffeeAlone,
    drinkCoffeeWithWife,
    goToWork,
    officeArrival,
    fatherAssignment,
    fatherOneToOne,
    atThreePM,
    goBackToOffice,
    taxi
}, "day01")